import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Row, Dropdown, FormControl, InputGroup, Button,Modal } from "react-bootstrap";
import { IMAGE_PATHS, DOMAIN_URL, formatDate, base64Encode, base64Decode, toCustomCamelCase } from '../../Functions/Constant';
import API from '../../Api/Api';
import { getStarColorClass } from '../../Functions/RatingLabelColor';
import FillterModal from '../../Pages/ComponentPage/FillterModal';
import ConfirmationPopup from '../../Components/ConfirmationPopup'
import StarRating from '../../Components/StarRating'
import TextWithReadMore from '../../Components/Readmore'
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import Confin from '../../Components/confin'
import './ProfilePage.css';
import ButtonsVariant from '../../Components/Button/ButtonVariant'; // Fixed: Use default import
import InfoTooltipRating from '../../Components/InfoTooltipRating'
import Accordions from '../../Components/Accordion/AccordionRatingView';
import PendiingReport from '../../Components/PendiingReport';
const ReviewCard = ({ review, bg }) => {
  const navigate = useNavigate();
  const loaderRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(null);
  const [draftCards, setDraftCards] = useState([]);
  const tooltipRef = useRef({});
  const [dataPage, setDataPage] = useState(1);
  const [filterValData, setFilterValData] = useState({});
  const [reportData, setReportData] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Professional Suggestions State
  const [profCards, setProfCards] = useState([]);
  const [profVisibleCards, setProfVisibleCards] = useState(4);
  const [profPage, setProfPage] = useState(1);
  const [profHasMore, setProfHasMore] = useState(true);
  const [profLoading, setProfLoading] = useState(false);
  const [profTotalCount, setProfTotalCount] = useState(0);
  
  // Academic Suggestions State
  const [acdCards, setAcdCards] = useState([]);
  const [acdVisibleCards, setAcdVisibleCards] = useState(4);
  const [acdPage, setAcdPage] = useState(1);
  const [acdHasMore, setAcdHasMore] = useState(true);
  const [acdLoading, setAcdLoading] = useState(false);
  const [acdTotalCount, setAcdTotalCount] = useState(0);
  const [showSkillsModal, setShowSkillsModal] = useState(false);
 

  const [cards, setCards] = useState([]); // All suggestion cards
  const [visibleCards, setVisibleCards] = useState(4);
  const [suggestionsPage, setSuggestionsPage] = useState(1); // Track API page
  const [hasMoreSuggestions, setHasMoreSuggestions] = useState(true); // Track if more suggestions exist
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [totalCount, setTotalCount] = useState(0); // Total number of suggestions from API
  const swiperRefs = useRef({});
  const swiperRefs1 = useRef({});
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  // Store refs for each menu dynamically
  const fetchFilterData = async (type) => {
    const payload = {
      filter_type: type,
    }
    const response = await API.post(`/reviews/filterdata`, payload);
    if (response.filterdata) {
      setFilterValData(response.filterdata);
    }
  };
 // Calculate total slides for academic cards
 const getTotalSlidesAcdCards = () => {
  const slidesPerView = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;
  const totalSlides = Math.ceil(acdTotalCount / slidesPerView);
  return totalSlides;
};

// Calculate total slides for professional cards
const getTotalSlidesProfCards = () => {
  const slidesPerView = window.innerWidth >= 1024 ? 4 : window.innerWidth >= 768 ? 2 : 1;
  console.log(profTotalCount,'----');
  return Math.ceil(profTotalCount / slidesPerView);
};

  // Fetch professional suggestions
  const fetchSuggestionsData = async (page = 1, append = false) => {
    setProfLoading(true);
    const limit = 4;
    try {
      const response = await API.get(`/user/suggestion_for_rating?page=${page}&limit=${limit}&type=1`); // Added type=1 for professional
      if (response) {
        const mergedCards = response.users || [];
        setProfTotalCount(response.pagination.total || 0);
        setProfPage(response.pagination.currentPage);
        if (mergedCards.length === 0) {
          setProfHasMore(false);
        } else {
          setProfCards((prev) => (append ? [...prev, ...mergedCards] : mergedCards));
          setProfHasMore(response.pagination.hasNextPage);
          if(page==1 && response.pagination.hasNextPage){
            fetchSuggestionsData(2,true);
          }
           
        }
      }
    } catch (error) {
      console.error("Error fetching professional suggestions:", error);
      setProfHasMore(false);
    } finally {
      setProfLoading(false);
    }
  };
  
  // Fetch academic suggestions
  const fetchASuggestionsData = async (page = 1, append = false) => {
    setAcdLoading(true);
    const limit = 4;
    try {
      const response = await API.get(`/user/suggestion_for_rating?page=${page}&limit=${limit}&type=2`); // Added type=2 for academic

      if (response) {
        const mergedCards = response.users || [];
        setAcdTotalCount(response.pagination.total || 0);
        setAcdPage(response.pagination.currentPage);
        if (mergedCards.length === 0 ) {
          setAcdHasMore(false);
        } else {
          setAcdCards((prev) => (append ? [...prev, ...mergedCards] : mergedCards));
          setAcdHasMore(response.pagination.hasNextPage);
          if(page==1 && response.pagination.hasNextPage){
            fetchASuggestionsData(2,true);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching academic suggestions:", error);
      setAcdHasMore(false);
    } finally {
      setAcdLoading(false);
    }
  };
  
  

  const handleLoadMoreSuggestions = () => {
    if (visibleCards + 4 <= cards.length) {
      // If there are enough cards in state, show 4 more
      setVisibleCards((prev) => prev + 4);
    } else if (hasMoreSuggestions) {
      // Fetch next page of suggestions
      const nextPage = suggestionsPage + 1;
      setSuggestionsPage(nextPage);
      fetchSuggestionsData(nextPage, true);
      setVisibleCards((prev) => prev + 4); // Increment visible cards
    }
  };



  const fetchDraftData = async () => {
    const response = await API.get(`/reviews/list-drafts`);
    if (response.result) {
      setDraftCards(response.result);
    }


  };
  // Close tooltips when clicking outside
  useEffect(() => {
    fetchFilterData(1);
    fetchSuggestionsData(1); // Fetch first page of suggestions
    
    
    fetchASuggestionsData(1); // Fetch first page of suggestions
    fetchDraftData();
    const handleClickOutside = (event) => {
      const tooltips = document.querySelectorAll('.report_review_cls');
      let isOutsideAll = true;

      tooltips.forEach((tooltip) => {
        if (tooltip && tooltip.contains(event.target)) {
          isOutsideAll = false;
        }
      });

      if (isOutsideAll) {
        tooltips.forEach((tooltip) => {
          tooltip.classList.remove("opacity-100", "visible");
          tooltip.classList.add("opacity-0", "invisible");
        });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [])
  const [showAllReplies, setShowAllReplies] = useState(false); // ✅ Define state

  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [hasMore, setHasMore] = useState(true); // Track if more reviews exist
  const [showPopup, setShowPopup] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [totalData, setTotalData] = useState(null);
  const [activeIndex1, setActiveIndex1] = useState(0); // Track the active slide index
  const [filterData, setFilterData] = useState({
    type: "",
    sort_by: "",
    ratings: "",
    organization: "",
    professional: "",
    acadaminc: "",
    page: 1,
    popular_mentions: "",
  });
  // Fetch reviews from API
  useEffect(() => {
    const filterDataPayLaod = filterData;
    if (filterDataPayLaod.page == 1) {
      setReviews([]);
    }
    fetchReviews(filterDataPayLaod);
  }, [filterData]);

  const updatePage = (pageNUmber) => {
    setFilterData({
      ...filterData, page: pageNUmber
    });
  };
  const fetchReviews = async (filterData) => {
    // if (!hasMore) return; // Stop fetching if no more reviews
    setLoading(true);
    setError(null);
    const dataLimit = 5;
    try {
      const response = await API.get(`/reviews/myreviews?page=${filterData.page}&limit=${dataLimit}&type=${filterData.type}&sort=${filterData.sort_by}&ratings=${filterData.ratings}&organization=${filterData.organization}&professional=${filterData.professional}&acadaminc=${filterData.acadaminc}&popular_mentions=${filterData.popular_mentions}&search=${searchQuery}`);
      if (response.reviews.length === 0) {
        setHasMore(false); // No more data
      } else {
        setDataPage(response.pagination.totalPages);
        setTotalData(response.pagination.totalReviews);
        if (response.pagination.currentPage <= 1) {
          setReviews(response.reviews);
        } else {
          setReviews(prevReviews => [...prevReviews, ...response.reviews]);
        }
        // Append new data
      }
    } catch (err) {
      setError("Failed to fetch reviews. Try again later.");
    } finally {
      setLoading(false);
    }
  };
  const [focusedReply, setFocusedReply] = useState({});
  const [replyText, setReplyText] = useState("");

  const toggleReplyBox = (index) => {
    setReviews((prevReviews) =>
      prevReviews.map((review, i) =>
        i === index ? { ...review, is_comment_open: !review.is_comment_open } : review
      )
    );
  };

  const handleReplyChange = (value) => {
    setReplyText(value);
  };
  const addComment = (index, newComment) => {
    setReviews((prevReviews) =>
      prevReviews.map((review, i) =>
        i === index
          ? {
            ...review,
            comment_list: [...review.comment_list, newComment] // Append new comment
          }
          : review
      )
    );
  };
  const addCommentApi = async (index) => {
    const payload = {
      review_id: reviews[index].review_id,
      comment: replyText
    }
    const response = await API.post(`/reviews/addcomment`, payload);
    response.comment.user_name = reviews[index].replied_by_name
    response.comment.user_pic = reviews[index].replied_by_pic
    response.comment.user_city = reviews[index].replied_by_location
    addComment(index, response.comment);
    setReplyText("");
  }
  const showReportComment = (idVal) => {
    const div = document.getElementById(idVal);
    if (div) {
      div.classList.toggle("opacity-100");
      div.classList.toggle("visible");
      div.classList.toggle("opacity-0");
      div.classList.toggle("invisible");
    }
  };
  const reportRespond = async (review_id, comment_id, idVal) => {
    const payload = {
      review_id: review_id,
      comment_id: comment_id
    }
    setIsLoading(true);
    const response = await API.post(`/reviews/reportresponse`, payload);
    setIsLoading(false);
    if(response.error_type== 1){
      setIsPopupOpen(true); // Show popup on error_type: 1
    }else{
      window.location.reload();
      showReportComment(idVal);
    }
    
  
  };
  const handleConfirm = () => {
    setIsPopupOpen(false);
    window.location.reload(); // Reload the page
  };
  const [showModal, setShowModal] = useState(false);

  const allSkills = Array.from({ length: 50 }, (_, i) => ({
    id: i + 1, // Unique ID for each skill
    name: `Skill ${i + 1}`,
    rating: (Math.random() * 2 + 3).toFixed(1), // Random rating between 3.0 to 5.0
  }));

  const [visibleSkills, setVisibleSkills] = useState(20); // Initially 20 skills
  const [selectedSkills, setSelectedSkills] = useState(new Set()); // Track selected skills




  useEffect(() => {
    //console.log("gdhghdj",selectedSkills);
    let skinl = Array.from(selectedSkills.keys())

    const typeFilterData = { ...filterData, popular_mentions: skinl.join(',') };
    //console.log(typeFilterData);
    setFilterData(typeFilterData);
    //console.log(skinl);
    // setFilterNData(filterData);
    // let 
  }, [selectedSkills]);
  // Toggle Skill Selection
  const handleSkillClick = (skill) => {
    setSelectedSkills((prevSelected) => {
      const newSelection = new Map(prevSelected);
      if (newSelection.has(skill.id)) {
        newSelection.delete(skill.id); // Unselect only this skill
      } else {
        newSelection.set(skill.id, skill.name); // Select this skill
      }
      return newSelection;
    });
  };
  const toggleMenu = (review_id) => {
    setMenuOpen(menuOpen === review_id ? null : review_id);
  };
  // Load more skills
  const handleLoadMore = () => {
    setVisibleSkills((prev) => prev + 20);
  };
  const filterMethod = (filterData) => {
    setFilterData(filterData);
  };


  const getFilterCount = (filterData) => {
    let fcnt = 0;
    if (filterData.ratings != "") {
      fcnt++;
    }
    if (filterData.organization != "") {
      fcnt++;
    }
    if (filterData.professional != "") {
      fcnt++;
    }
    if (filterData.acadaminc != "") {
      fcnt++;
    }
    return fcnt > 0 ? '(' + fcnt + ')' : '';
  }

  const handleDelete = async (values) => {
    setLoading(true);
    try {
      await API.delete(`/reviews/${values}`);
      window.location.reload();
      setShowPopup(false);

      const filterDataPayLaod = filterData;
      fetchReviews(filterDataPayLaod);
    } catch (error) {
      console.error("Error deleting:", error);
    }
    setLoading(false);
  };
  const showReportReview = (idVal) => {
    const divc = document.getElementById(idVal);
    const divs = document.querySelectorAll('.report_review_cls'); // Select all elements with class
    divs.forEach(div => {
      if (divc != div) {
        div.classList.remove("opacity-100");
        div.classList.remove("visible");
        div.classList.add("opacity-0");
        div.classList.add("invisible");
      }

    });

    if (divc) {
      divc.classList.toggle("opacity-100");
      divc.classList.toggle("visible");
      divc.classList.toggle("opacity-0");
      divc.classList.toggle("invisible");
    }

  };
  const handleClose = (user_id) => {
    setCards((prev) => prev.filter((card) => card.user_id !== user_id));
  };
  const handleReviewNow = async (user_id, tag_data_id, rate_type) => {
    const payload = {
      user_id: user_id,
      type: rate_type,
      tag_data_id: tag_data_id,
    };

    try {
      const response = await API.post(`/user/initiate-rating`, payload);

      if (response && response.review_id) {
        window.location.href = `/review/` + base64Encode(response.review_id);
      } else {
        console.error("Review ID not returned:", response);
      }
    } catch (error) {
      console.error("Error initiating rating:", error);
    }
  };
  const menuRef = useRef(null);
  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(null); // Close the menu
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && filterData.page < dataPage && !loading) {
          updatePage(filterData.page + 1);
        }
      },
      {
        root: null, // Use viewport as root
        rootMargin: '100px', // Trigger 100px before reaching the target
        threshold: 0.1, // Trigger when 10% of the target is visible
      }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [filterData.page, dataPage, loading]);
  // Handle Search
  const handleSearch = () => {
    setFilterData({ ...filterData, page: 1 }); // Reset to first page on new search
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };
  const [selectedType, setSelectedType] = useState("Type"); // State for Type dropdown
  const [selectedSort, setSelectedSort] = useState("Sort by");
  const changeType = (type) => {
    let typeLabel = "Type"; // Default label
    switch (type) {
      case 0:
        typeLabel = "All";
        break;
      case 1:
        typeLabel = "Professional";
        break;
      case 2:
        typeLabel = "Academic";
        break;
    }
    setSelectedType(typeLabel); // Update the selected type label
    setFilterData({ ...filterData, type, page: 1 }); // Update filterData and reset page
  };

  const changeSort = (type) => {
    let sortLabel = "Sort by"; // Default label
    switch (type) {
      case 0:
        sortLabel = "All";
        break;
      case 1:
        sortLabel = "Highest Rate";
        break;
      case 2:
        sortLabel = "Lowest Rate";
        break;
    }
    setSelectedSort(sortLabel); // Update the selected sort label
    setFilterData({ ...filterData, sort_by: type, page: 1 }); // Update filterData and reset page
  };
  const getTotalSlides = () => {
    const slidesPerView = window.innerWidth >= 1024 ? 4 : window.innerWidth >= 768 ? 2 : 1;
    return Math.ceil(cards.length / slidesPerView);
  };
  const [activeIndex, setActiveIndex] = useState(0); // Track the active slide index
  const swiperRef = useRef(null);
  const swiperRef1 = useRef(null);

  // Handle slide change for professional slider
  const handleProfSlideChange = (swiper) => {
    setActiveIndex(swiper.snapIndex);
    const totalSlides = getTotalSlidesProfCards();
    console.log('--rrrrrrrr-----',swiper.snapIndex,totalSlides );
    if (profHasMore && !profLoading) {
      const nextPage = profPage + 1;
      setProfPage(nextPage);
      fetchSuggestionsData(nextPage, true);
      //setProfVisibleCards((prev) => prev + 4);
    }
  };
  
  // Handle slide change for academic slider
  const handleAcdSlideChange = (swiper) => {
    setActiveIndex1(swiper.snapIndex);
    const totalSlides = getTotalSlidesAcdCards();
    if ( acdHasMore && !acdLoading) {
      const nextPage = acdPage + 1;
      setAcdPage(nextPage);
      fetchASuggestionsData(nextPage, true);
    }
  };
    const [selectedReviewId, setSelectedReviewId] = useState(null);
  const normalizeSkillsData = (categories) => {
    if (!Array.isArray(categories)) return [];
    return categories.map((category) => ({
      title: category.name || 'Unnamed Category',
      rating: category.avg_rating != null && !isNaN(category.avg_rating) ? Number(category.avg_rating) : 0,
      skills: Array.isArray(category.skills)
        ? category.skills.map((subSkill) => ({
          name: subSkill.skill_name || 'Unnamed Sub-Skill',
          rating: subSkill.rating != null && !isNaN(subSkill.rating) ? Number(subSkill.rating) : 0,
          // total: subSkill.total || 0,
        }))
        : [],
    }));
  };

  // Get all categories for a specific review_id
  const getReviewCategories = (reviews, reviewId) => {
    const review = reviews.find((r) => r.review_id === reviewId);
    return review && Array.isArray(review.categories) ? review.categories : [];
  };

  // Update handleOpenSkillsModal to accept review_id
  const handleOpenSkillsModal = (reviewId) => {
    setSelectedReviewId(reviewId);
    setShowSkillsModal(true);
  };

  const handleCloseSkillsModal = () => {
    setShowSkillsModal(false);
  };

  return (<>
    <div
      enableReinitialize
      className={`custm-bg ${draftCards && draftCards.length > 0 ? "pt-[100px] pb-[100px] px-4" : " pb-[100px] md:pb-[50px]"
        }`}
    >
      <Container>
        <Row>
          <Col lg={12} className="p-0">
            {draftCards && draftCards.length > 0 && (
              <>
                <h3 class="text-[28px] font-bold text-black mb-0 leading-[2.0]">Pick Up Where You Left Off</h3>
                <div className="flex flex-wrap gap-4  ">
                  {draftCards.map((card) => (
                    <div
                      key={card.review_id}
                      className="sm:!w-[100%] md:!w-[100%] w-[32%] bg-white rounded-lg border shadow-sm p-4 relative cursor-pointer " onClick={() => navigate(`/review/${base64Encode(card.review_id)}`)}
                    >
                      <div className="flex">
                        <img
                          crossorigin="anonymous"
                          src={card.profile_picture ? `${DOMAIN_URL + card.profile_picture}?t=${Date.now()}` : IMAGE_PATHS.USER}
                          className="w-[80px] h-[80px] rounded-full object-cover border border-gray-300"
                          alt={toCustomCamelCase(card.name)}
                        />
                        <div className="flex flex-col justify-center ml-4 pr-4">
                          <h4 className="text-lg font-bold text-gray-900 mb-0 leading-[1.2]">{toCustomCamelCase(card.name)}</h4>
                          <p className="font-medium text-[16px] text-gray-700 leading-[1.6]">
                            {card.company_name || card.school_name || ''}
                          </p>
                          {
                            card.profile_title != null && (<p className="font-medium text-[16px] text-gray-700 leading-[1.4] draft_profile_title"> {toCustomCamelCase(card.profile_title.length > 50 ? `${card.profile_title.substring(0, 50)}... ` : card.profile_title || '')}</p>)
                          }
                          <span className="leading-[1.2]"><StarRating rating={card.overall_rating ? card.overall_rating : 0} starSize={15} /></span>

                        </div>

                        {/* 3-dot Menu Button */}
                        <div className="ml-auto relative">
                          <button
                            className="text-gray-600 hover:text-black"
                            // onClick={() => toggleMenu(card.review_id)}
                            onClick={(event) => {
                              event.stopPropagation(); // Prevent click from bubbling to parent div
                              toggleMenu(card.review_id);
                            }}
                          >
                            <span className="rond-cls relative inline-block"> <i className="fas fa-ellipsis-h cursor-pointer text-gray-700 hover:text-black w-[25px]"></i></span>

                          </button>

                          {/* Dropdown */}
                          {menuOpen === card.review_id && (
                            <div
                              ref={menuRef}
                              className="absolute right-0 top-8  w-40 sm:w-[13rem] md:w-[13rem] pt-[16px] pb-[16px] bg-white border border-gray-300 rounded-lg shadow-lg z-10 "
                            >
                              <button
                                className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                onClick={() => navigate(`/review/${btoa(card.review_id)}`)}
                              >
                                <i className="fas fa-edit mr-2"></i> Edit Review
                              </button>
                              <button
                                className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  setSelectedValue(card.review_id);
                                  setShowPopup(true);
                                }}
                              >
                                <i className="fas fa-trash mr-2"></i> Delete
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </div>
    <section enableReinitialize className={`${cards && cards.length > 0 || draftCards && draftCards.length > 0 ? `bg-white` : "custm-bg !pb-[90px]  "} pt-[20px] pb-[60px] px-4`}>
      <Container>

        <Row>
          <Col lg={12} className="p-0">
          {profCards && profCards.length > 0 && (
                <>
                  <h3 className="text-[28px] font-bold text-black mb-0 mt-[55px] leading-[0.9]">Review Your Professional Connections</h3>
                  <div className="client-slider-wrapper relative review-card-container swiper-navigation-04 swiper-navigation-suggestion">
                    <Swiper
                      modules={[Pagination, Autoplay, Navigation]}
                      pagination={{ clickable: true }}
                      navigation
                      
                      spaceBetween={25}
                      breakpoints={{
                        0: { slidesPerView: 1 , slidesPerGroup:1},
                        768: { slidesPerView: 2 , slidesPerGroup:2},
                        1024: { slidesPerView: 4 ,slidesPerGroup:4},
                      }}
                      onSwiper={(swiper) => {
                        swiperRefs.current = swiper;
                        swiper.autoplay?.stop();
                      }}
                      onSlideChange={handleProfSlideChange}
                     
                      ref={swiperRef}
                      className="slider_suggestion pt-[15px] w-full h-auto pb-4"
                    >
                      {profCards.map((card) => (
                        <SwiperSlide key={card.user_id} className="w-full h-auto bg-white p-4 rounded-xl border">
                          <div className="relative flex flex-col items-center justify-between h-full">
                            <div>
                              <div className="flex justify-center">
                                <img
                                  crossorigin="anonymous"
                                  src={`${DOMAIN_URL + card.profile_picture}?t=${Date.now()}`}
                                  alt={card.name}
                                  className="w-20 h-20 rounded-full object-cover border-2 border-white shadow-sm"
                                />
                              </div>
                              <div className="text-center mt-3">
                                <h4 className="text-lg font-bold text-gray-900 mb-0">{card.name}</h4>
                                <p className="font-medium text-gray-700 leading-[1.6] draft_profile_title-r">{card.profile_title}</p>
                                <p className="text-gray-700">{card.city_name}</p>
                                <p className="text-[11px] text-gray-500 mt-1 leading-4" title={card.w_name}>
                                  {card.data_type === 1
                                    ? `Worked Together at ${card.w_name}`
                                    : card.data_type === 2
                                      ? `Studied Together at ${card.w_name}`
                                      : card.w_name}
                                </p>
                              </div>
                            </div>
                            <div className="flex justify-center mt-3">
                              <ButtonsVariant
                                ariaLabel="button"
                                href="#"
                                className="mx-[10px]"
                                variant="whiteToBlack"
                                size="xs"
                                title="Review Now"
                                onClick={() => handleReviewNow(card.user_id, card.w_id, card.data_type)}
                              />
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    {profCards && profCards.length > 0 && (
                      <>
                        {activeIndex > 0 && (
                         
                          <div onClick={() => swiperRef.current.swiper.slidePrev()} className="swiper-button-prev absolute" style={{ left: "15px" }}>
                            <i style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', paddingRight: "5px" }} className="solid-icon-Arrow-Left"></i>
                          </div>
                        )}
                        {activeIndex < getTotalSlidesProfCards() - 1 && (
                          <div onClick={() => swiperRef.current.swiper.slideNext()} className="swiper-button-next absolute" style={{ right: "15px" }}>
                            <i style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', paddingLeft: "5px" }} className="solid-icon-Arrow-Right"></i>
                          </div>
                        )}
                      </>
                    )}
                    {profLoading && <div>Loading more professional suggestions...</div>}
                  </div>
                </>
              )}
          </Col>
        </Row>

        <Row>
          <Col lg={12} className="p-0">
          {acdCards && acdCards.length > 0 && (
                <>
                  <h3 className="text-[28px] font-bold text-black mb-0 mt-[55px] leading-[0.9]">Review Your Academic Connections</h3>
                  <div className="client-slider-wrapper relative review-card-container swiper-navigation-04 swiper-navigation-suggestion">
                    <Swiper
                      modules={[Pagination, Autoplay, Navigation]}
                      pagination={{ clickable: true }}
                      navigation
                      spaceBetween={25}
                      breakpoints={{
                        0: { slidesPerView: 1 , slidesPerGroup:1},
                        768: { slidesPerView: 2 , slidesPerGroup:2},
                        1024: { slidesPerView: 4 ,slidesPerGroup:4},
                      }}
                      onSwiper={(swiper) => {
                        swiperRefs1.current = swiper;
                        swiper.autoplay?.stop();
                      }}
                      onSlideChange={handleAcdSlideChange}
                      ref={swiperRef1}
                      className="slider_suggestion pt-[15px] w-full h-auto pb-4"
                    >
                      {acdCards.map((card) => (
                        <SwiperSlide key={card.user_id} className="w-full h-auto bg-white p-4 rounded-xl border">
                          <div className="relative flex flex-col items-center justify-between h-full">
                            <div>
                              <div className="flex justify-center">
                                <img
                                  crossorigin="anonymous"
                                  src={`${DOMAIN_URL + card.profile_picture}?t=${Date.now()}`}
                                  alt={card.name}
                                  className="w-20 h-20 rounded-full object-cover border-2 border-white shadow-sm"
                                />
                              </div>
                              <div className="text-center mt-3">
                                <h4 className="text-lg font-bold text-gray-900 mb-0">{card.name}</h4>
                                <p className="font-medium text-gray-700 leading-[1.6] draft_profile_title-r">{card.profile_title}</p>
                                <p className="text-gray-700">{card.city_name}</p>
                                <p className="text-[11px] text-gray-500 mt-1 leading-4" title={card.w_name}>
                                  {card.data_type === 1
                                    ? `Worked Together at ${card.w_name}`
                                    : card.data_type === 2
                                      ? `Studied Together at ${card.w_name}`
                                      : card.w_name}
                                </p>
                              </div>
                            </div>
                            <div className="flex justify-center mt-3">
                              <ButtonsVariant
                                ariaLabel="button"
                                href="#"
                                className="mx-[10px]"
                                variant="whiteToBlack"
                                size="xs"
                                title="Review Now"
                                onClick={() => handleReviewNow(card.user_id, card.w_id, card.data_type)}
                              />
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    {acdCards && acdCards.length > 0 && (
                      <>
                        {activeIndex1 > 0 && (
                          <div onClick={() => swiperRef1.current.swiper.slidePrev()} className="swiper-button-prev absolute" style={{ left: "15px" }}>
                            <i style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', paddingRight: "5px" }} className="solid-icon-Arrow-Left"></i>
                          </div>
                        )}
                        {activeIndex1 < getTotalSlidesAcdCards() - 1 && (
                          <div onClick={() => swiperRef1.current.swiper.slideNext()} className="swiper-button-next absolute" style={{ right: "15px" }}>
                            <i style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', paddingLeft: "5px" }} className="solid-icon-Arrow-Right"></i>
                          </div>
                        )}
                      </>
                    )}
                    {acdLoading && <div>Loading more academic suggestions...</div>}
                  </div>
                </>
              )}
          </Col>
        </Row>
        {filterValData && filterValData.popular_skills && filterValData.popular_skills.length > 0 && (
          <Row>
            <Col lg={12} className="p-0">
              {/* Header Section */}
              <h3 className="text-[28px] font-bold text-black mb-0 mt-[43px] dkw ">{filterValData && filterValData.popular_skills && filterValData.popular_skills.length > 0 ? `All Reviews (${totalData})` : "No Reviews Yet"}
              </h3>
              {/* <p className="text-gray-700 text-[14px] mb-3 leading-[1.5]">
              Reviews are the subjective opinion of Tripadvisor members and not of Tripadvisor LLC. Tripadvisor performs checks on reviews as part of our industry- leading trust& safety standards. Read our transparency report to learn.
            </p> */}
              {filterValData && filterValData.popular_skills && filterValData.popular_skills.length > 0 ? (
                <>
                  <div className="mt-4 flex flex-wrap items-center rounded-lg space-x-3 mb-2">
                    <div className="flex space-x-3">
                      {/* Filter Dropdown */}
                      <Row className="justify-center">

                        <div className="relative w-full " onClick={handleSearch} >
                          <input
                            type="text"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={handleKeyPress}

                            className="w-full pl-[38px] pr-4 py-2 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300 text-sm text-gray-700 placeholder-gray-400 shadow-sm fomc-clds !leading-[1.5]"
                          />
                          <div className="absolute inset-y-0 left-[18px] flex items-center pl-3 pointer-events-none">
                            <svg viewBox="0 0 24 24" width="20px" height="20px" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.12 4.14a5.99 5.99 0 1 0 0 11.98 5.99 5.99 0 0 0 0-11.98m-7.49 5.99a7.49 7.49 0 1 1 13.299 4.728L21.37 20.3l-1.06 1.061-5.44-5.44A7.49 7.49 0 0 1 2.63 10.13"></path></svg>
                          </div>
                        </div>
                      </Row>

                      {/* Language Dropdown */}
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          className="px-4 py-2 text-sm font-medium border rounded-full bg-white flex items-center review_search_tab"
                        >
                          {selectedType} <i className="fas fa-chevron-down ml-2 text-sm"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => changeType(0)}>All</Dropdown.Item>
                          <Dropdown.Item onClick={() => changeType(1)}>Professional</Dropdown.Item>
                          <Dropdown.Item onClick={() => changeType(2)} >Academic</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>

                      {/* Sorting Dropdown */}
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          className="px-4 py-2 text-sm font-medium border rounded-full bg-white flex items-center review_search_tab"
                        >
                          {selectedSort}<i className="fas fa-chevron-down ml-2 text-sm"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => changeSort(0)}>All</Dropdown.Item>
                          <Dropdown.Item onClick={() => changeSort(1)} >Highest Rate</Dropdown.Item>
                          <Dropdown.Item onClick={() => changeSort(2)} >Lowest Rate</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </>
              ) : (<></>)}



            </Col>
          </Row>
        )}

        {
          reviews.map((review, reviewIndex) => (
            <Row>
              <Col lg={12} className="p-0">
                {/* Review Card */}
                <div className="bg-white border rounded-lg p-5 mt-[15px] mb-2">
                {(review.report_review === 1 || (review.comment_list.length>0 && review.comment_list[0].is_report==1)) && (
            <div className="flex justify-center items-center xs:items-baseline mb-3">
              <span className="text-red-500 text-md sm:pt-[15px] flex items-center gap-2">
                <img
                  src="https://jobcritics.com/assets/img/biar/warning2.webp"
                  alt="Warning Icon"
                  width="15"
                  height="15"
                  className="inline-block"
                />
                <span>This content is under review and temporarily hidden.</span>
              </span>
            </div>
          )}
                <div className={`transition-all duration-300 ${
              (review.report_review === 1 || (review.comment_list.length>0 && review.comment_list[0].is_report==1)) ? 'filter blur-sm pointer-events-none opacity-60' : ''
            }`} >
                    <Row>
                      {/* Left Section: Profile & Rating */}
                      <Col lg={4} md={4} sm={12} className="pr-4">

                        <div >
                          <img
                            crossorigin="anonymous"
                            src={review.profile_pic != null ? DOMAIN_URL + review.profile_pic : IMAGE_PATHS.USER}
                            alt={review.full_name}
                            className="w-14 h-14 rounded-full border border-gray-300 object-cover"
                          />
                        </div>
                        <div className="flex items-center space-x-3">
                          <div className="leading-[1.5]">
                            <h2 className="font-medium text-[18px] text-[#000] mb-0 leading-[1.4]">
                              {review.full_name}
                            </h2>
                            {
                              review.profile_title != null && (<p className="font-medium text-[16px] text-[#000] text-gray-700 ">{review.profile_title.length > 50 ? `${review.profile_title.substring(0, 50)}... ` : review.profile_title || ''}</p>)
                            }


                            {/* <span className="text-xs bg-black text-white px-2 py-1  font-medium">
                              {review.type == 1 ? 'Worked Together' : 'Study Together'}
                            </span> */}
                          </div>
                        </div>

                        {/* Rating */}
                        <div className="flex items-start space-x-3 py-3">
                          {/* Rating Number */}
                          <div className="mt-[8px]">
                            <span className="text-[40px] font-bold text-gray-900 lt">
                              {review.overall_rating}
                            </span>
                          </div>

                          {/* Rating Text & Stars */}
                          <div className="leading-[1.4]">
                            <InfoTooltipRating className="text-[16px] font-bold text-gray-900" rating={review.overall_rating} />


                            {/* Star Ratings */}
                            <div className="flex items-center mb-2">

                              {/* {[...Array(5)].map((_, index) => (
                                <i
                                  key={index}
                                  className={`fas fa-star text-[16px] ${index < Math.round(review.overall_rating)
                                    ? "yellow-class"
                                    : "text-gray-300"
                                    }`}
                                ></i>
                              ))} */}
                              <StarRating rating={review?.overall_rating} starSize={15} />

                              {/* <span className="text-gray-600 text-[14px] ml-1">
                                {review.totalReview}
                              </span> */}
                            </div>
                          </div>
                        </div>

                        {/* Rating Progress Bars */}
                        <div >
                          {review.categories ? review.categories.map((item, index) => (
                            <div key={index} className="flex flex-col space-y-0 pr-[80px] sm:pr-[0px] md:pr-[0px]">
                              {/* Label */}
                              <span className="text-gray-900 text-sm font-medium leading-[1] pt-[8px]">{item.name}</span>

                              {/* Progress Bar */}
                              <div className="flex items-center space-x-2 h-[19px]">
                                <div className="flex-1 h-[12px] bg-gray-200 rounded-full overflow-hidden relative">
                                  <div
                                    className="h-full yellow-b rounded-full"
                                    style={{ width: `${(item.avg_rating / 5) * 100}%` }}
                                  ></div>
                                </div>
                                <span className="text-gray-900 text-sm font-medium">{item.avg_rating.toFixed(1)}</span>
                              </div>
                            </div>
                          )) : null}
                        </div>

                      </Col>

                      {/* Right Section: Review Content */}
                      <Col lg={8} md={8} sm={12} className="pr-0">
                        {/* <div className="flex justify-between items-center">
                          <span className="text-red-500 text-md sm:pt-[15px] flex items-center gap-2">
                            {review.is_comment_report && review.is_comment_report == 1 ? (
                              <>
                                <img
                                  crossorigin="anonymous"
                                  src="https://jobcritics.com/assets/img/biar/warning2.webp"
                                  alt="Warning Icon"
                                  width="15"
                                  height="15"
                                  className="inline-block"
                                />
                                <span>Reply reported and is currently being assessed.</span>
                              </>
                            ) : null}
                          </span>
                        </div> */}
                        <div className="flex justify-between items-center">

                          <span className="text-gray-500 text-md sm:pt-[15px]">

                            Reviewed by
                            {review.review_tag === 1 ? " Friend" :
                              review.review_tag === 2 ? " Teacher" :
                                review.review_tag === 3 ? " HR" :
                                  review.review_tag === 4 ? " Colleague" :
                                    review.review_tag === 5 ? " Manager" : ""} from {review.type == 1 ? review.company_name : review.school_name}


                          </span>


                          <div className="flex items-center">
                            <span className="text-gray-500 text-sm sm:w-max md:w-max">
                              <span className="m-2">{formatDate(new Date(review.created_at))}</span>
                            </span>
                            <div className="relative">
                              <span className="rond-cls relative inline-block">
                                <i
                                  className="fas fa-ellipsis-h cursor-pointer text-gray-700 hover:text-black pl-[5px]"
                                  onClick={() => showReportReview(`c_review${reviewIndex}`)}
                                ></i>
                              </span>

                              {/* Tooltip Menu */}
                              {(
                                <div
                                  id={`c_review${reviewIndex}`}
                                  ref={(el) => (tooltipRef.current[`review_${reviewIndex}`] = el)}
                                  className="absolute right-0 mt-2 bg-white shadow-lg border rounded-md px-4 py-2 text-sm w-max z-10 
                    transition-opacity duration-200 ease-in-out transform opacity-0 invisible scale-100 report_review_cls p"
                                >
                                  <div className="absolute top-[-8px] right-4 w-4 h-4 bg-white rotate-45 border-l-2 border-t"></div>
                                  <button
                                    className="w-full text-left text-black hover:text-blue-600"
                                    onClick={() => navigate(`/review/${btoa(review.review_id)}`)}
                                  >
                                    <i className="fas fa-edit mr-2"></i> Edit
                                  </button>
                                  <button
                                    className="w-full text-left text-black hover:text-blue-600"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      setSelectedValue(review.review_id);
                                      setShowPopup(true);
                                    }}
                                  >
                                    <i className="fas fa-trash mr-2"></i> Delete
                                  </button>

                                </div>
                              )}
                            </div>
                          </div>

                        </div>
                        <h3 className="text-lg font-bold text-gray-900 mt-2 mb-3">
                          {review.type == 1 ? 'Professional Reviews' : 'Academic Reviews'}
                          {review.is_anonymously === 0 && (
                            <span className="text-xs bg-gray-200 text-gray-700 px-2 py-1 font-medium ml-2">
                              Anonymous
                            </span>
                          )}
                        </h3>
                        <p className="text-gray-700 text-[14px] mb-3 leading-[1.5] "><TextWithReadMore text={review.comments} /></p>

                        {/* Tags */}
                        <div className="mt-3 flex flex-wrap gap-2">
                          {review.subCategoryIdArr ? review.subCategoryIdArr.map((category, index) => (
                            <span
                              key={index}
                              className="flex items-center px-2 py-0 font-medium text-black text-sm rounded-full gap-2 h-m bg-white"
                            >
                              <i className={`fas fa-star mr-1 ${getStarColorClass(category.avg_rating)}`}></i> <span className="black-class"> {category.name}</span>
                            </span>
                          )) : null}
                          {/* {review.subCategoryIdArr && review.subCategoryIdArr.length > 0 && ( */}
                            <button
                              onClick={() => handleOpenSkillsModal(review.review_id)}
                              className="text-black font-bold text-sm cursor-pointer hover:bg-gray-200 px-3 py-1 rounded"
                            >
                              View All Skills
                            </button>
                          {/* )} */}
                        </div>
                        {/* {review.comment_list.length === 0 && (
                          <>
                            <div className="text-gray-700 cursor-pointer hover:text-blue-500 hover:underline w-fit pt-2" onClick={() => toggleReplyBox(reviewIndex)} >
                              Reply
                            </div>

                            {review.is_comment_open && (
                              <div className="flex items-start w-full">
                                <div className="flex-1 bg-white rounded-lg p-2 transition-all duration-200 border border-black fomc-clsr">
                                  <textarea
                                    className="w-full border-none rounded-lg p-2 text-sm focus:outline-none focus:ring-0"
                                    placeholder="Write a reply..."
                                    rows="1"
                                    maxLength={1000}
                                    value={replyText}
                                    onChange={(e) => handleReplyChange(e.target.value)}
                                  ></textarea>

                                  <div className="flex items-center justify-end py-0 pr-[2px] pl-[7px]">
                                    <button
                                      onClick={() => addCommentApi(reviewIndex)}
                                      className={`btn-explore-yellow ${!replyText.trim()
                                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                        : ""
                                        }`}
                                      disabled={!replyText.trim()}
                                    >
                                      Reply
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )} */}

                        {/* Reply Section */}
                        {review.comment_list.length > 0 && (
                          <div className="mt-4 p-4 border-l-2 !pr-0">
                            {review.comment_list.slice(0, showAllReplies ? review.comment_list.length : 1).map((item, index) => (
                              <div key={index} className="pb-2">
                                <div className="flex justify-between items-start">
                                  {/* User Profile */}
                                  <div className="flex items-center space-x-3 leading-[1.4]">
                                    <img
                                      crossorigin="anonymous"
                                      src={item.user_pic != null ? DOMAIN_URL + item.user_pic : IMAGE_PATHS.USER}
                                      alt={item.user_name}
                                      className="w-[40px] h-[40px] rounded-full border border-gray-300 object-cover"
                                    />
                                    <div>
                                      <h4 className="font-medium text-[16px] text-[#000] mb-0 leading-[1]">
                                        {item.user_name}
                                      </h4>
                                      {
                                        item.profile_title != null && (<span className="text-gray-600 text-sm">{item.profile_title.length > 50 ? `${item.profile_title.substring(0, 50)}... ` : item.profile_title || ''}</span>)
                                      }


                                    </div>
                                  </div>
                                  <div className="flex items-baseline">
                                    <p className="text-gray-500 text-sm m-2 sm:w-max md:w-max"> {formatDate(new Date(item.created_at))}</p>
                                    {/* Three-dot menu with tooltip */}
                                    {item.me == 0 && ( // ✅ Condition added
                                      <div className="relative">
                                        <span className="rond-cls relative inline-block">
                                          <i
                                            className="fas fa-ellipsis-h cursor-pointer text-gray-700 hover:text-black  pl-[5px]"

                                            onClick={() => showReportComment(`c_item${reviewIndex}-${index}`)}
                                          ></i>
                                        </span>

                                        <div
                                          id={`c_item${reviewIndex}-${index}`}
                                          ref={(el) => (tooltipRef.current[`comment_${reviewIndex}_${index}`] = el)}
                                          className={`absolute  right-0 mt-2 bg-white shadow-lg border rounded-md px-4 py-2 text-sm w-[165px] z-10 opacity-0 invisible`}
                                        >
                                          <div className="absolute top-[-8px] right-4 w-4 h-4 bg-white rotate-45 border-l-2 border-t"></div>
                                          <button
                                            className="w-full text-left text-black hover:text-blue-600"
                                            onClick={() => {
                                              setReportData({ review_id: review.review_id, comment_id: item._id, idVal: `c_item${reviewIndex}-${index}` });
                                              setShowPopup(true); // Open confirmation
                                            }}
                                          >
                                            <i className="solid-icon-Flag-2 text-[10px] mr-2"></i>Report response
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Reply Content */}

                                <p className="text-gray-700 text-sm mb-3 leading-[1.5] pl-[50px] mt-1 ">
                                  <TextWithReadMore text={item.comment} />
                                </p>

                                {/* Signature */}
                                {/* <h4 className="text-gray-700 text-sm leading-[1] mb-0 pl-[50px]">
                                  {item.user_name}
                                </h4>
                                <span className="text-gray-700 text-sm leading-[1] pl-[50px]">
                                  {item.user_city}
                                </span> */}
                              </div>

                            ))}

                            {/* Show "Load More Replies" button if more replies exist */}
                            {review.comment_list.length > 5 && (
                              <button
                                className="text-black font-bold text-sm cursor-pointer hover:bg-gray-200 px-2 py-1 rounded pl-[50px]"
                                onClick={() => setShowAllReplies(prev => !prev)}
                              >
                                {showAllReplies ? "Collapse Replies" : "Load More Replies"}
                              </button>
                            )}
                          </div>
                        )}
                      </Col>
                    </Row>
                    </div>
                  </div>
              </Col>
            </Row>

          ))
        }
        {!loading && filterData.page < dataPage && (
          <div
            ref={loaderRef}
            className="h-10"
            aria-hidden="true"
          />
        )}
      </Container>
         <Modal
              show={showSkillsModal}
              onHide={handleCloseSkillsModal}
              centered
              size="sm"
              className="skills-modal"
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title className="text-lg font-bold text-gray-900">Key Skills</Modal.Title>
              </Modal.Header>
              <Modal.Body className="relative pb-0">
                <Accordions data={normalizeSkillsData(getReviewCategories(reviews, selectedReviewId))} />
              </Modal.Body>
      
            </Modal>
      {
        showPopup && (selectedValue || reportData) && (
          <Confin
            isOpen={showPopup}
            title={reportData ? "Report This Reply?" : "Confirm Deletion?"}
            message={
              reportData
                ? "Flag this reply for inappropriate or misleading content."
                : "Do you want to permanently delete this entry? This cannot be undone."
            }
            onClose={() => {
              setShowPopup(false);
              setSelectedValue(null);
              setReportData(null);
            }}
            onConfirm={async () => {
              if (reportData) {
                await reportRespond(reportData.review_id, reportData.comment_id, reportData.idVal);
                setReportData(null);
              } else {
                await handleDelete(selectedValue);
                window.location.reload();
              }
              setShowPopup(false);
            }}
            loading={false}
            showCancelButton={true}
            actionType={reportData ? "report" : "delete"}
          />
        )
      }
      <PendiingReport
        isOpen={isPopupOpen}
        onConfirm={handleConfirm}
        loading={isLoading}
      />


      <FillterModal filtertype="1" filterValData={filterValData} filterData={filterData} filterMethod={filterMethod} show={showModal} handleClose={() => setShowModal(false)} />
    </section >
  </>
  );
};

const ReviewPage = ({ bg }) => {
  return (
    <ReviewCard bg={bg} />
  );
};

export default ReviewPage;
